var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "right-body", attrs: { id: "addClouds" } }, [
    _c(
      "div",
      { staticClass: "all-drives" },
      [
        _c("div", { staticClass: "right-cont-middle" }, [
          _c("div", { staticClass: "right-cont-middle-position" }, [
            _c("span", { staticClass: "connect-desc" }, [
              _vm._v(_vm._s(_vm.$t("language.addCloud.connectDesc")))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon order sort",
              class: [_vm.rightBoShow ? "" : "order-click"],
              on: { click: _vm.cloudOrderSort }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right-cont-body" }, [
          _c(
            "div",
            { class: [_vm.rightBoShow ? "cont-box" : "cont-box-order"] },
            [
              _vm.rightBoShow
                ? _c(
                    "div",
                    {
                      staticClass: "drive-add-clouds-up",
                      class: {
                        "up-clouds-none":
                          !_vm.addCloudLineUp || !_vm.addCloudLineUp.length
                      }
                    },
                    [
                      _c("div", { staticClass: "add-txt" }, [
                        _vm._v(_vm._s(_vm.$t("language.addCloud.peCloud")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "drive-add-cloud-top" },
                        [
                          _vm._l(_vm.clouds, function(cloud) {
                            return _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.$store.state.isLiteMode &&
                                      !_vm.isBusinessCloud(cloud),
                                    expression:
                                      "$store.state.isLiteMode && !isBusinessCloud(cloud)"
                                  }
                                ],
                                key: cloud,
                                staticClass: "lite_cloud",
                                on: {
                                  click: function($event) {
                                    return _vm.readyAddDrive(cloud)
                                  }
                                }
                              },
                              [
                                _c("div", { class: "drive-icon-" + cloud }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.cloudTypeToName(cloud)))
                                ])
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.addCloudLineUp, function(item, index) {
                            return item.appName.indexOf("_v2") == -1 &&
                              item.appName != "oneDrive" &&
                              item.appName != "googlePhotos"
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.$store.state.isLiteMode,
                                        expression: "!$store.state.isLiteMode"
                                      }
                                    ],
                                    key: index,
                                    staticClass: "drive-add-cloud",
                                    style: {
                                      height: _vm.getAddCloudHeight() + "Px"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.addCloudDialog(item)
                                      }
                                    }
                                  },
                                  [
                                    item.appName
                                      ? _c(
                                          "div",
                                          { staticClass: "add-cloud-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "add-cloud-center"
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "cloud cloud-size cloudPosition",
                                                  class: item.appName
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "add-cloud-item-name"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "language.addCloud." +
                                                            item.appName
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.rightBoShow
                ? _c(
                    "div",
                    { staticClass: "drive-add-clouds-down" },
                    [
                      _c("div", { staticClass: "add-txt" }, [
                        _vm._v(_vm._s(_vm.$t("language.addCloud.buCloud")))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.clouds, function(cloud) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.$store.state.isLiteMode &&
                                  _vm.isBusinessCloud(cloud),
                                expression:
                                  "$store.state.isLiteMode && isBusinessCloud(cloud)"
                              }
                            ],
                            key: cloud,
                            staticClass: "lite_cloud",
                            on: {
                              click: function($event) {
                                return _vm.readyAddDrive(cloud)
                              }
                            }
                          },
                          [
                            _c("div", { class: "drive-icon-" + cloud }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.cloudTypeToName(cloud)))
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.addCloudLineDown, function(item, index) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.$store.state.isLiteMode,
                                expression: "!$store.state.isLiteMode"
                              }
                            ],
                            key: index,
                            staticClass: "drive-add-cloud",
                            style: { height: _vm.getAddCloudHeight() + "Px" },
                            on: {
                              click: function($event) {
                                return _vm.addCloudDialog(item)
                              }
                            }
                          },
                          [
                            item.appName
                              ? _c("div", { staticClass: "add-cloud-item" }, [
                                  _c(
                                    "div",
                                    { staticClass: "add-cloud-center" },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "cloud cloud-size cloudPosition",
                                        class: item.appName
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "add-cloud-item-name" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.addCloud." +
                                                  item.appName
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.rightBoShow
                ? _c(
                    "div",
                    { staticClass: "drive-add-clouds-order" },
                    [
                      _vm._l(_vm.sortedClouds, function(cloud) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.$store.state.isLiteMode,
                                expression: "$store.state.isLiteMode"
                              }
                            ],
                            key: cloud,
                            staticClass: "lite_cloud",
                            on: {
                              click: function($event) {
                                return _vm.readyAddDrive(cloud)
                              }
                            }
                          },
                          [
                            _c("div", { class: "drive-icon-" + cloud }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.cloudTypeToName(cloud)))
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.reorder, function(item, index) {
                        return item.appName.indexOf("_v2") == -1 &&
                          item.appName != "oneDrive"
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.$store.state.isLiteMode,
                                    expression: "!$store.state.isLiteMode"
                                  }
                                ],
                                key: index,
                                staticClass: "drive-add-cloud-order",
                                style: {
                                  height: _vm.getAddCloudHeight() + "Px"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.addCloudDialog(item)
                                  }
                                }
                              },
                              [
                                item.appName
                                  ? _c(
                                      "div",
                                      { staticClass: "add-cloud-item" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "add-cloud-center" },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "cloud cloud-size cloudPosition",
                                              class: item.appName
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "add-cloud-item-name"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.addCloud." +
                                                        item.appName
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "selectInfo-footer" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.snapTaskIconShow,
                    expression: "snapTaskIconShow"
                  }
                ],
                staticClass: "icon scaling-open scaling-open-position",
                on: {
                  click: function($event) {
                    return _vm.snapTasksOpen()
                  }
                }
              },
              [
                _c("snapTaskDialog", {
                  ref: "snapTaskDialog",
                  on: {
                    cancel: function($event) {
                      return _vm.cancelUpload($event)
                    }
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("addCloudDialog", { ref: "addCloudDialog" }),
        _vm._v(" "),
        _c("addFtpDialog", { ref: "addFtpDialog" }),
        _vm._v(" "),
        _c("detailedProgrssDialog", { ref: "detailedProgrss" }),
        _vm._v(" "),
        _c("retryFailedDialog", { ref: "retryFailedDialog" }),
        _vm._v(" "),
        _c("cancelAllDialog", { ref: "cancelAllDialog" }),
        _vm._v(" "),
        _c("addNasDialog", { ref: "addNasDialog" }),
        _vm._v(" "),
        _c("addSpecialDialog", { ref: "addSpecialDialog" }),
        _vm._v(" "),
        _c("appleTipsDialog", { ref: "appleTipsDialog" }),
        _vm._v(" "),
        _c("appleICloudDriveDiaLog", { ref: "appleICloudDriveDiaLog" }),
        _vm._v(" "),
        _c("liteAddDrive", {
          attrs: { auth: _vm.auth },
          on: {
            submit: function($event) {
              return _vm.addCloud()
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86124086", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86124086","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/add_cloud.vue
// module id = null
// module chunks = 